module.exports = __webpack_public_path__ + "static/img/45.91f6dbe1.png";